import { registerLicense } from '@syncfusion/ej2-base';

export const license = (() => {
  let licensed = false;
  return () => {
    if (!licensed && process.env.REACT_APP_EJ2_LICENSE) {
      registerLicense(process.env.REACT_APP_EJ2_LICENSE);
    }
    licensed = true;
  };
})();
